<template>
  <MainLayout>
    <v-container class="mt-10">
      <v-row>
        <v-breadcrumbs :items="breadcrumbs">
          <template v-slot:prepend>
            <v-icon icon="$vuetify" size="small"></v-icon>
          </template>
        </v-breadcrumbs>
        <v-divider></v-divider>
      </v-row>
      <v-row>
        <v-col>
          <v-btn @click="showAddCategoryDialog" color="primary float-right"
            >Kategori Ekle</v-btn
          >
          <!-- Kullanıcı Ekle Butonu -->
        </v-col>
      </v-row>
      <v-dialog v-model="dialog" max-width="600px">
        <v-card>
          <v-card-title>Açıklama</v-card-title>
          <v-card-text>{{ selectedDescription }}</v-card-text>
          <v-card-actions>
            <v-btn text @click="dialog = false">Kapat</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="addCategoryDialog" max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">Kategori Ekle</span>
          </v-card-title>
          <v-card-text>
            <v-form ref="form" v-model="valid">
              <v-text-field
                v-model="newCategory.name"
                label="Ad"
                :rules="[rules.required]"
                required
              ></v-text-field>
              <v-select
                v-model="newCategory.parent_id"
                :items="categoryList"
                item-text="title"
                item-value="id"
                label="Üst Kategori"
                :rules="[rules.required]"
                required
              ></v-select>
              <v-file-input
                v-model="newCategory.image"
                label="Resim"
                variant="solo-inverted"
              ></v-file-input>
              <v-text-field
                v-model="newCategory.description"
                label="Açıklama"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="addCategory">Ekle</v-btn>
            <v-btn color="grey" text @click="addCategoryDialog = false"
              >İptal</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-row>
        <v-col>
          <v-data-table
            :headers="headers"
            :items="categoryList"
            class="elevation-1"
          >
            <template v-slot:item="{ item }">
              <tr>
                <td>
                  <v-btn @click="item.showChildren = !item.showChildren">
                    {{ item.title }}
                    <v-icon>{{
                      item.showChildren ? "mdi-chevron-up" : "mdi-chevron-down"
                    }}</v-icon>
                  </v-btn>
                </td>
                <td>
                  {{
                    item.parent_id === 0
                      ? "Ana Kategori"
                      : item.parent
                      ? item.parent.title
                      : "N/A"
                  }}
                </td>
                <td>{{ item.slug }}</td>
                <td>
                  <v-icon @click="openDialog(item.description)" color="primary"
                    >mdi-comment-text</v-icon
                  >
                </td>
                <td>{{ item.image }}</td>
                <td class="text-end">
                  <v-btn
                    size="30"
                    @click="deleteCategory(item.id)"
                    color="orange"
                    class="icon-size"
                    icon
                  >
                    <v-icon color="white" size="20">mdi-delete</v-icon>
                  </v-btn>
                  <v-btn
                    size="30"
                    @click="editCategory(item.id)"
                    color="orange"
                    class="icon-size ml-3"
                    icon
                  >
                    <v-icon color="white" size="20">mdi-pencil</v-icon>
                  </v-btn>
                </td>
              </tr>
              <template v-if="item.showChildren">
                <tr v-for="child in item.children" :key="child.id">
                  <td style="padding-left: 20px">{{ child.title }}</td>
                  <td>{{ item.title }}</td>
                  <!-- Üst kategori ismi -->
                  <td>{{ child.slug }}</td>
                  <td>
                    <v-icon
                      @click="openDialog(child.description)"
                      color="primary"
                      >mdi-comment-text</v-icon
                    >
                  </td>
                  <td>{{ child.image }}</td>
                  <td class="text-end">
                    <v-btn
                      size="30"
                      @click="deleteCategory(child.id)"
                      color="orange"
                      class="icon-size"
                      icon
                    >
                      <v-icon color="white" size="20">mdi-delete</v-icon>
                    </v-btn>
                    <v-btn
                      size="30"
                      @click="editCategory(child.id)"
                      color="orange"
                      class="icon-size ml-3"
                      icon
                    >
                      <v-icon color="white" size="20">mdi-pencil</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </MainLayout>
</template>

<script>
import { mapState } from "vuex";

import mainService from "@/services/mainService";
import MainLayout from "@/layouts/MainLayout.vue";
import Swal from "sweetalert2"; // SweetAlert2'yi içe aktar
import { useFetch } from "@/composables/useFetch";

export default {
  name: "CategoryList",
  components: {
    MainLayout,
  },
  created() {
    //  this.categoryList = mainService.list('categories');
  },
  data() {
    return {
      breadcrumbs: [
        {
          title: "Anasayfa",
          disabled: false,
          href: "pDashboard",
        },
        {
          title: "Kategori İşlemleri",
          disabled: false,
          href: "",
        },
      ],
      headers: [
        {
          title: "Adı",
          value: "title",
        },
        {
          title: "Üst Kategori",
          value: "parent",
        },
        {
          title: "Slug",
          value: "slug",
        },
        {
          title: "Açıklama",
          value: "description",
        },
        {
          title: "Resim",
          value: "image",
        },
        {
          title: "İşlemler",
          value: "actions",
          sortable: false,
          align:'end'
        }, // Aksiyonlar için
      ],

      dialog: false,
      selectedDescription: "",
      loading: false, // Yükleniyor durumu
      search: "", // Arama metni
      addCategoryDialog: false, // Kullanıcı ekleme modal durumu
      newCategory: {
        // Yeni kullanıcı bilgileri
        name: "",
        parent_id: 0,
        description: "",
        image: "",
      },
      valid: false, // Form geçerliliği
      rules: {
        required: (value) => !!value || "Bu alan gereklidir.",
      },
      statusItems: [
        {
          text: "Aktif",
          value: 1,
        },
        {
          text: "Pasif",
          value: 0,
        },
      ],
    };
  },

  computed: {
    ...mapState(["Category"]), // Vuex state'inden Category'ı al
  },
  setup() {
    const {
      data: categoryList,
      loadingCategory,
      error,
      fetchData,
    } = useFetch("categories");

    fetchData();

    return {
      categoryList,
      loadingCategory, // Burada loading'ı doğrudan kullanıyoruz
      error,
    };
  },
  methods: {
    openDialog(description) {
      this.selectedDescription = description; // Seçilen açıklamayı ayarla
      this.dialog = true; // Dialog'u aç
    },
    onFileChange(event) {
      const file = event.target.files[0]; // Seçilen dosyayı al
      if (file) {
        this.newCategory.image = file; // Dosyayı newCategory.image değişkenine ata
      }
    },
    showAddCategoryDialog() {
      this.resetNewCategory(); // Formu sıfırla
      this.addCategoryDialog = true; // Modalı göster
    },

    statusProps(statusItems) {
      return {
        title: statusItems.text,
        value: statusItems.value,
      };
    },

    async addCategory() {
      const formData = new FormData(); // FormData nesnesini oluştur
      formData.append("name", this.newCategory.name);
      formData.append("parent_id", this.newCategory.parent_id);
      formData.append("description", this.newCategory.description);
      formData.append("image", this.newCategory.image); // Resim dosyasını ekle

      try {
        const response = await mainService.add(formData, "categories"); // Sunucuya gönder
        console.log("Kategori eklendi:", response);
        const responses = await mainService.list("categories");
        this.categoryList = responses;
        this.addCategoryDialog = false; // Modalı aç
        this.resetNewCategory(); // Yeni stok formunu sıfırla
      } catch (error) {
        console.error("Kategori eklenirken hata oluştu:", error);
        // Hata durumunda yapılacaklar...
      }
    },

    async editCategory(CategoryId) {
      // Kullanıcı bilgilerini al
      const CategoryToEdit = this.categoryList.find(
        (Category) => Category.id === CategoryId
      );
      if (CategoryToEdit) {
        this.newCategory = {
          ...CategoryToEdit,
        }; // Kullanıcı bilgilerini form alanlarına doldur
        this.addCategoryDialog = true; // Modalı aç
      }
    },

    async deleteCategory(CategoryId) {
      const { value: confirmDelete } = await Swal.fire({
        title: "Silmek istediğinize emin misiniz?",
        text: "Bu işlem geri alınamaz!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet, sil!",
        cancelButtonText: "Hayır, iptal et!",
      });

      if (confirmDelete) {
        try {
          await mainService.delete(CategoryId, "categories"); // Kullanıcıyı silmek için servisi çağır
          const responses = await mainService.list("categories");
          this.categoryList = responses;
          Swal.fire("Silindi!", "Kullanıcı başarıyla silindi.", "success");
        } catch (error) {
          console.error("Kullanıcı silinirken hata oluştu:", error);
          Swal.fire("Hata!", "Kullanıcı silinirken bir hata oluştu.", "error");
        }
      } else {
        Swal.fire(
          "İptal edildi",
          "Kullanıcı silme işlemi iptal edildi.",
          "info"
        );
      }
    },

    resetNewCategory() {
      this.newCategory = {
        name: "",
        parent_id: 0,
        description: "",
        image: "",
      };
    },
  },
};
</script>

<style scoped>
/* İsteğe bağlı stil ayarları */
.v-data-table {
  background-color: #ffffff;
  /* Beyaz arka plan */
  border-radius: 8px;
  /* Köşeleri yuvarla */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  /* Hafif gölge */
}

.icon-size {
  width: 30px;
  height: 30px;
}
</style>
